/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "catalogmigrator": {
        "nested": {
          "external": {
            "nested": {
              "PrepareMigrationExternalRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitNickname": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "catalogType": {
                    "type": "squareup.catalogmigrator.common.CatalogType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "StartMigrationExternalRequest": {
                "fields": {
                  "catalogImportToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "importProvider": {
                    "type": "squareup.catalogmigrator.common.ImportProvider",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateAdditionalAttributesExternalRequest": {
                "fields": {
                  "catalogImportToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "menuAttributes": {
                    "type": "squareup.catalogmigrator.common.MenuAttributes",
                    "id": 2
                  },
                  "retailAttributes": {
                    "type": "squareup.catalogmigrator.common.RetailAttributes",
                    "id": 3
                  },
                  "healthAndBeautyAttributes": {
                    "type": "squareup.catalogmigrator.common.HealthAndBeautyAttributes",
                    "id": 4
                  },
                  "staffAttributes": {
                    "type": "squareup.catalogmigrator.common.StaffAttributes",
                    "id": 5
                  }
                },
                "nested": {
                  "catalog_details": {
                    "oneof": ["menuAttributes", "retailAttributes", "healthAndBeautyAttributes", "staffAttributes"]
                  }
                }
              },
              "ExternalThirdPartyMigrationService": {
                "methods": {
                  "PrepareMigration": {
                    "requestType": "squareup.catalogmigrator.external.PrepareMigrationExternalRequest",
                    "responseType": "squareup.catalogmigrator.common.PrepareMigrationResponse"
                  },
                  "StartMigration": {
                    "requestType": "squareup.catalogmigrator.external.StartMigrationExternalRequest",
                    "responseType": "squareup.catalogmigrator.common.StartMigrationResponse"
                  },
                  "UpdateAdditionalAttributes": {
                    "requestType": "squareup.catalogmigrator.external.UpdateAdditionalAttributesExternalRequest",
                    "responseType": "squareup.catalogmigrator.common.UpdateAdditionalAttributesResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.catalogmigrator?.nested?.external?.nested?.PrepareMigrationExternalRequest && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.external?.nested?.StartMigrationExternalRequest && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.external?.nested?.UpdateAdditionalAttributesExternalRequest && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.external?.nested?.ExternalThirdPartyMigrationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrepareMigrationExternalRequest @ squareup/catalogmigrator/external.proto at 13:1
 */
export const PrepareMigrationExternalRequest = $root.lookupType('squareup.catalogmigrator.external.PrepareMigrationExternalRequest');
fixType(PrepareMigrationExternalRequest, {
  unitToken: {
    required: true
  },
  unitNickname: {
    required: true
  },
  catalogType: {
    required: true
  }
});
Builder.createAndAttachToType(PrepareMigrationExternalRequest);
/**
 * SOURCE StartMigrationExternalRequest @ squareup/catalogmigrator/external.proto at 19:1
 */
export const StartMigrationExternalRequest = $root.lookupType('squareup.catalogmigrator.external.StartMigrationExternalRequest');
fixType(StartMigrationExternalRequest, {
  catalogImportToken: {
    required: true
  }
});
Builder.createAndAttachToType(StartMigrationExternalRequest);
/**
 * SOURCE UpdateAdditionalAttributesExternalRequest @ squareup/catalogmigrator/external.proto at 24:1
 */
export const UpdateAdditionalAttributesExternalRequest = $root.lookupType('squareup.catalogmigrator.external.UpdateAdditionalAttributesExternalRequest');
fixType(UpdateAdditionalAttributesExternalRequest, {
  catalogImportToken: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateAdditionalAttributesExternalRequest);
/**
 * SOURCE ExternalThirdPartyMigrationService @ squareup/catalogmigrator/external.proto at 36:1
 */
export const ExternalThirdPartyMigrationService = $root.lookupService('squareup.catalogmigrator.external.ExternalThirdPartyMigrationService');